import i18n from 'i18next'

const TITLE_FLASH_INTERVAL_MS = 500

let defaultTitle = 'WSS'
let tikkTakk = 0
let unreadCount = 0
let timer = null

const getUnreadPrefix = () => (unreadCount > 0 ? `(${unreadCount})` : '')

const stopTitleFlash = () => {
  if (timer != null) {
    clearInterval(timer)
    timer = null
  }
  tikkTakk = 0
  unreadCount = 0
  if (typeof document !== 'undefined') {
    document.title = defaultTitle
  }
}

const changeWindowTitle = senderName => {
  const unreadPrefix = getUnreadPrefix()
  if (tikkTakk !== 0) {
    tikkTakk += 1
  } else {
    stopTitleFlash()
    return
  }

  if (tikkTakk === 4) {
    document.title = `${senderName} ${i18n.t('Notifications.NewMessage.SentYou', 'sent you a message')}`
  } else if (tikkTakk === 6) {
    tikkTakk = 1
    document.title = `${unreadPrefix}${defaultTitle}`
  }
}

/** Capture the baseline document title once (call on app boot). */
export const initDocumentTitle = (title = typeof document !== 'undefined' ? document.title : 'WSS') => {
  defaultTitle = title || 'WSS'
}

/**
 * Blink the window title between the default and a sender-specific message, mirroring the legacy
 * Polymer tikkTakk behaviour. Resets when the user focuses the tab.
 */
export const flashTitleForIncomingMessage = ({ senderName }) => {
  if (typeof document === 'undefined' || !senderName) return

  unreadCount += 1
  if (tikkTakk === 0) {
    tikkTakk = 3
    changeWindowTitle(senderName)
    timer = setInterval(() => changeWindowTitle(senderName), TITLE_FLASH_INTERVAL_MS)
  }
}

export const resetTitleFlash = stopTitleFlash

if (typeof window !== 'undefined') {
  window.addEventListener('focus', stopTitleFlash)
}
